import { render } from "./MobileSplashScreen.vue?vue&type=template&id=c05cc1c8&scoped=true"
import script from "./MobileSplashScreen.vue?vue&type=script&lang=js"
export * from "./MobileSplashScreen.vue?vue&type=script&lang=js"

import "./MobileSplashScreen.vue?vue&type=style&index=0&id=c05cc1c8&lang=scss&scoped=true"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c05cc1c8"]])

export default __exports__